export default __webpack_public_path__ + "static/media/corner-3.7b033e8c.png";